import { CREATE_CONFIGUREEXPIRATIONREPONSES_FAILURE, CREATE_CONFIGUREEXPIRATIONREPONSES_REQUEST, CREATE_CONFIGUREEXPIRATIONREPONSES_SUCCESS } from "../Types";

const initialState = {
    loading: false,
    error: null,
    confExpirReponse: null,
};
 
const ConfigurExpirationReponseReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_CONFIGUREEXPIRATIONREPONSES_REQUEST:
            return { ...state, loading: true, error: null };
        case CREATE_CONFIGUREEXPIRATIONREPONSES_SUCCESS:
            return { ...state, loading: false, confExpirReponse: action.payload };
        case CREATE_CONFIGUREEXPIRATIONREPONSES_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
}; 

export default ConfigurExpirationReponseReducer;

